import { normalizeRoutePath } from '~/utils/route'

export default (props: {
  fbEventName: string
  eventName: string
  items: CategoryMenuItem[]
}) => {
  const route = useRoute()
  const router = useRouter()

  const selectedTab = ref(route.path)
  const isActive = (path: string): boolean => normalizeRoutePath(path) === normalizeRoutePath(route.path)

  // Get active item for dropdown label
  const activeItem = computed(() =>
    props.items.find(item => isActive(item.path)) || props.items[0],
  )

  const { analyticEvent, fbPixelEvent } = useAnalytic()
  const eventCategoryButton = (title: string) => {
    analyticEvent({
      ga4ActionName: props.eventName,
      ga4Label: title,
    })
    fbPixelEvent({
      fbCategory: 'trackCustom',
      fbEvent: props.fbEventName,
      fbValue: { label: title },
    })
  }

  const handleTabClick = (item: CategoryMenuItem) => {
    eventCategoryButton(item.title)
    router.push(item.path)
  }

  // Keep selected tab in sync with route
  watch(
    () => route.path,
    (newPath) => {
      selectedTab.value = newPath
    },
  )

  return {
    isActive,
    selectedTab,
    activeItem,
    handleTabClick,
  }
}
